import { apiSlice } from "../../app/apiSlice";
import { logout, setCredentials } from "../auth/authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          console.error("Login failed:", err);
        }
      },
    }),

    requestOtp: builder.mutation({
      query: ({ email, recaptchaToken }) => ({
        url: "/auth/request-otp",
        method: "POST",
        body: { email, recaptchaToken },
      }),
    }),

    verifyOtp: builder.mutation({
      query: ({ email, otp, recaptchaToken, sessionId }) => ({
        url: "/auth/verify-otp",
        method: "POST",
        body: { email, otp, recaptchaToken, sessionId },
      }),
    }),

    resendOtp: builder.mutation({
      query: ({ email, recaptchaToken }) => ({
        url: "/auth/resend-otp",
        method: "POST",
        body: { email, recaptchaToken },
      }),
    }),

    forgotPassword: builder.mutation({
      query: (body) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body,
      }),
    }),

    resetPassword: builder.mutation({
      query: ({ resetToken, password }) => ({
        url: `/auth/reset-password/${resetToken}`,
        method: "POST",
        body: { password },
      }),
    }),

    sendLogout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(logout());
          dispatch(apiSlice.util.resetApiState());
        } catch {
          // ignore
        }
      },
    }),

    refresh: builder.mutation({
      query: () => ({
        url: "/auth/refresh",
        method: "GET",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled; // Await the refresh query
          const { accessToken } = data; // Extract access token
          dispatch(setCredentials({ accessToken })); // Dispatch action to set credentials
        } catch (err) {
          console.error("Token refresh error:", err); // Log error for troubleshooting
        }
      },
    }),
  }),
});

export const {
  useRequestOtpMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useLoginMutation,
  useRefreshMutation,
  useSendLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApiSlice;
